// İndirim badge'lerinde boşluk düzeltmesi
document.addEventListener('DOMContentLoaded', function() {
  function fixBadgeSpacing() {
    // İndirim badge'lerini bul ve düzelt
    const badgeElements = document.querySelectorAll('.hdt-badge__on-sale');
    
    badgeElements.forEach(function(badge) {
      const text = badge.textContent;
      // %19İndirim formatını %19 İndirim olarak değiştir
      if (text.includes('İndirim') && !text.includes(' İndirim')) {
        const newText = text.replace(/(%\d+)İndirim/, '$1 İndirim');
        badge.textContent = newText;
        badge.classList.add('badge-fixed');
      }
    });
  }
  
  // İlk yükleme
  fixBadgeSpacing();
  
  // 500ms sonra tekrar kontrol et
  setTimeout(fixBadgeSpacing, 500);
  
  // 1 saniye sonra tekrar kontrol et
  setTimeout(fixBadgeSpacing, 1000);
  
  // Dinamik olarak eklenen badge'ler için observer
  const observer = new MutationObserver(function(mutations) {
    let shouldFix = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.classList && node.classList.contains('hdt-badge__on-sale')) {
            shouldFix = true;
          }
          const badges = node.querySelectorAll ? node.querySelectorAll('.hdt-badge__on-sale') : [];
          if (badges.length > 0) {
            shouldFix = true;
          }
        }
      });
    });
    
    if (shouldFix) {
      setTimeout(fixBadgeSpacing, 100);
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
});